type IconProps = {
	width?: number;
	height?: number;
	color?: string;
}

export const CommentDisputeIcon = (props:IconProps) => {
	const {
		width = 24,
		height = 24,
		color = '#404040'
	} = props;
	return (
        <svg role={'img'} fill={color} viewBox={'0 0 24 24'} height={height} width={width} xmlns={'http://www.w3.org/2000/svg'}>
			<path d={'M9.707 13.707 12 11.414l2.293 2.293 1.414-1.414L13.414 10l2.293-2.293-1.414-1.414L12 8.586 9.707 6.293 8.293 7.707 10.586 10l-2.293 2.293z'}></path>
			<path d={'M20 2H4c-1.103 0-2 .897-2 2v18l5.333-4H20c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14H6.667L4 18V4h16v12z'}></path>
		</svg>
	);
};
